module.exports = __webpack_public_path__ + "static/media/Artboard – 8.93070e6d.svg";